<template>
  <v-app-bar app fixed height="50" class="top-bar">
    <v-row align="center" no-gutters>
      <v-col>
        <!-- <img alt="Prime Investor logo" src="@/assets/logo.png" /> -->
        <v-toolbar-title class="font-weight-bold text-h5">
          Prime Stock Screener
        </v-toolbar-title>
      </v-col>
      <v-col class="d-none d-sm-flex flex-row-reverse">
        <v-tabs right hide-slider background-color="header" color="white">
          <v-tab @click="loadNewScreener()">New Screen</v-tab>
          <v-menu
            offset-y
            lefts
            :min-width="599"
            :max-width="599"
            :close-on-content-click="false"
            v-model="openSavedScreeners"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-tab v-bind="attrs" v-on="on"> Saved Screeners </v-tab>
            </template>
            <SavedScreens :open.sync="openSavedScreeners" />
          </v-menu>
          <v-menu offset-y left :min-width="599" :max-width="599">
            <template v-slot:activator="{ on, attrs }">
              <v-tab v-bind="attrs" v-on="on"> Premium Screeners </v-tab>
            </template>
            <AllScreens />
          </v-menu>
          <v-menu offset-y left>
            <template v-slot:activator="{ on, attrs }">
              <v-tab v-bind="attrs" v-on="on"> How to use </v-tab>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in helpLinks"
                :key="`helpLinks-${index}`"
                @click="openHelpPage(item.link)"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-tabs>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<style>
.top-bar {
  background-color: var(--v-header-base) !important;
  color: #fff !important;
  box-shadow: 0 0 12px 0 rgba(151, 141, 141, 0.15) !important;
  transition: background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s !important;
}
</style>

<script>
import AllScreens from "@/components/report/AllScreens.vue";
import SavedScreens from "@/components/report/SavedScreens.vue";
export default {
  name: "TopBar",
  components: { AllScreens, SavedScreens },
  data: () => ({
    openSavedScreeners: false,
    helpLinks: [
      {
        title: "Guide to Filters",
        link: "https://primeinvestor.in/a-guide-to-prime-screener/",
      },
      {
        title: "Guide to Premium screeners",
        link: "https://primeinvestor.in/a-guide-to-premium-screeners/",
      },
      {
        title: "Youtube Screener tutorial",
        link: "https://www.youtube.com/watch?v=67DHPiIougg&t=2s",
      },
    ],
  }),
  methods: {
    openHelpPage(link) {
      window.open(link, "_blank");
    },
    loadNewScreener() {
      this.$store.commit("setScreener", {
        slug: "BASIC",
        name: "New Screen",
        custom: false,
      });
    },
  },
};
</script>
